import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // for navigation
import axiosClient from "../../axios";

const CouponList = () => {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [processingId, setProcessingId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCoupons();
  }, []);

  const fetchCoupons = async () => {
    setLoading(true);
    try {
      const response = await axiosClient.get("/api/coupons");
      setCoupons(response.data);
      setError("");
    } catch (err) {
      console.error(err);
      setError("Failed to load coupons.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this coupon?")) return;

    setProcessingId(id);
    try {
      await axiosClient.delete(`/api/coupons/${id}`);
      setCoupons((prev) => prev.filter((c) => c.id !== id));
    } catch (err) {
      alert("Delete failed.");
    } finally {
      setProcessingId(null);
    }
  };

  const handleApprove = async (id) => {
    setProcessingId(id);
    try {
      await axiosClient.put(`/api/coupons/${id}`, { is_active: true });
      setCoupons((prev) =>
        prev.map((c) => (c.id === id ? { ...c, is_active: true } : c))
      );
    } catch (err) {
      alert("Approval failed.");
    } finally {
      setProcessingId(null);
    }
  };

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center">
        <h4>Coupons</h4>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/xl-admin/add-coupon")}
        >
          + Add Coupon
        </button>
      </div>

      {loading && <div className="alert alert-info">Loading coupons...</div>}
      {error && <div className="alert alert-danger">{error}</div>}

      {!loading && !error && (
        <div className="table-responsive">
          <table className="table table-bordered table-striped mt-3 align-middle">
            <thead className="table-dark">
              <tr>
                <th>User ID</th>
                <th>Code</th>
                <th>Discount</th>
                <th>Status</th>
                <th>Valid Until</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {coupons.length > 0 ? (
                coupons.map((coupon) => (
                  <tr key={coupon.id}>
                    <td>{coupon.user_id ?? "-"}</td>
                    <td>{coupon.code}</td>
                    <td>{coupon.discount_value}%</td>
                    <td>
                      {coupon.is_active ? (
                        <span className="text-success fw-bold">Active</span>
                      ) : (
                        <span className="text-danger fw-bold">Inactive</span>
                      )}
                    </td>
                    <td>{new Date(coupon.valid_until).toLocaleDateString()}</td>
                    <td>
                      {!coupon.is_active && (
                        <button
                          className="btn btn-sm btn-success me-2"
                          disabled={processingId === coupon.id}
                          onClick={() => handleApprove(coupon.id)}
                        >
                          {processingId === coupon.id
                            ? "Approving..."
                            : "Approve"}
                        </button>
                      )}
                      <button
                        className="btn btn-sm btn-danger"
                        disabled={processingId === coupon.id}
                        onClick={() => handleDelete(coupon.id)}
                      >
                        {processingId === coupon.id ? "Deleting..." : "Delete"}
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No coupons available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CouponList;
